export const loginConfig = {
  useNewContentBox: true,
  useNewLoadingPage: true,
};
